import React from "react"
import PropTypes from "prop-types"
import Loader from "react-loader-spinner"
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

export default class GagImage extends React.Component {

    constructor(props) {
        super(props)

        this.options = this.props.gag.postPostOptions.map(postPostOption => {
            return postPostOption.postOption.name
        })

        this.state = {
            visibleMedia: false,
            mediaWidth:null
        }

        this.handleMediaLoad = this.handleMediaLoad.bind(this)
    }

    handleMediaLoad(media) {

        let mediaWidth = media.target.width
        if (this.options.includes('x0.5')) {
            mediaWidth /=2
        }
        else if (this.options.includes('x1.5')) {
            mediaWidth *=1.5
        }
        else if (this.options.includes('x2')) {
            mediaWidth *=2
        }
        else if (this.options.includes('x3')) {
            mediaWidth *=3
        }

        this.setState({visibleMedia: true,  mediaWidth: mediaWidth}, function(){
            this.props.handleMediaLoad(media)
        })
    }

    render() {
        return <>
                <Loader
                    className="media-loader"
                    type="Grid"
                    color={"hsla(" + this.props.color + ", 30%, 50%, 0.3"}
                    width={50}
                    visible={!this.state.visibleMedia}
                />
                <img
                    src={process.env.REACT_APP_API_URL + '/api/gagmedia_file_content/' + this.props.gag.id}
                    alt={this.props.gag.name}
                    onLoad={this.handleMediaLoad}
                    width={(this.state.mediaWidth !== null?this.state.mediaWidth:'')}
                    style={{
                        display: (this.state.visibleMedia) ? 'inline-block' : 'none'
                    }}

                />
        </>
    }
}

GagImage.propTypes = {
    gag: PropTypes.object.isRequired,
    handleMediaLoad: PropTypes.func.isRequired
}